import { useState } from "react";

export default function useViewPreference(pageKey, defaultMode = "grid", defaultSize = 3) {
  const modeKey = `view_mode_${pageKey}`;
  const sizeKey = `view_size_${pageKey}`;

  const [viewMode, setViewModeState] = useState(
    () => localStorage.getItem(modeKey) || defaultMode
  );
  const [imageSize, setImageSizeState] = useState(
    () => Number(localStorage.getItem(sizeKey)) || defaultSize
  );

  const setViewMode = (mode) => {
    setViewModeState(mode);
    localStorage.setItem(modeKey, mode);
  };

  const setImageSize = (size) => {
    setImageSizeState(size);
    localStorage.setItem(sizeKey, size);
  };

  return { viewMode, setViewMode, imageSize, setImageSize };
}
